import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import { selectDistance } from "../../redux/actions";
import { HotelParamsLine, DropdownContainer } from "../index";
import { Checkbox } from "../../components";
import { getCategory, slugify } from '../../utils';
import { Router } from "../../routes";

const { ParamsOption, CheckboxList } = HotelParamsLine;

const mapStateToProps = state => ({
  distance: state.userPreferences.distance,
  product: state.userPreferences.product,
  market: state.userPreferences.city.market,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleDistanceSelection: selectDistance,
}, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
class DistanceSelector extends Component {
  static propTypes = {
    distance: PropTypes.instanceOf(Object),
    handleDistanceSelection: PropTypes.func,
    currentDropdown: PropTypes.string,
    handleDropdownClick: PropTypes.func,
    handleCloseDropdown: PropTypes.func,
    product: PropTypes.string,
    market: PropTypes.string,
  };

  getDistanceTitle = (distanceLo, distanceHi) => {
    if (distanceHi === 0 && distanceLo === 0) {
      return 'Distance';
    }

    if (distanceLo === 0) {
      return `< ${distanceHi} miles`;
    }

    if (distanceLo === 100) {
      return `> ${distanceLo} miles`;
    }

    return `${distanceLo}-${distanceHi} miles`;
  };

  handleDistanceSelect = evt => {
    const { handleDistanceSelection, distance, product, market } = this.props;
    const { target } = evt;
    const { value } = target;

    const newDistanceLo = Number(value.split('-')[0]);
    const newDistanceHi = Number(value.split('-')[1]);

    const selectedDistanceLo = Number(distance.distanceLo);
    const selectedDistanceHi = Number(distance.distanceHi);

    Router.pushRoute('search', {
      ...Router.query,
      marketName: slugify(market),
      category: getCategory(product),
      distanceLo: newDistanceLo === selectedDistanceLo ? 0 : newDistanceLo,
      distanceHi: newDistanceHi === selectedDistanceHi ? 0 : newDistanceHi,
    }, { shallow: true });

    handleDistanceSelection({
      distanceLo: newDistanceLo === selectedDistanceLo ? 0 : newDistanceLo,
      distanceHi: newDistanceHi === selectedDistanceHi ? 0 : newDistanceHi,
    });
  };

  render() {
    const { getDistanceTitle } = this;
    const { currentDropdown, handleDropdownClick, handleCloseDropdown, distance } = this.props;
    const distanceHi = Number(distance.distanceHi);
    const distanceLo = Number(distance.distanceLo);

    return (
      <Fragment>
        <ParamsOption
          type="button"
          name="distance"
          onClick={handleDropdownClick}
          isOpened={currentDropdown === 'distance'}
          isActive={distanceHi !== 0}
        >
          {getDistanceTitle(distanceLo, distanceHi)}
        </ParamsOption>
        {currentDropdown === 'distance' && (
          <DropdownContainer
            name="distance"
            handleCloseButtonClick={handleCloseDropdown}
            onClickOutside={handleCloseDropdown}
          >
            <CheckboxList onChange={this.handleDistanceSelect}>
              <li>
                <Checkbox
                  name="< 10 miles"
                  value="0-10"
                  checked={distanceHi === 10}
                  id="< 10 miles"
                  label="< 10 miles"
                />
              </li>
              <li>
                <Checkbox
                  name="10 - 20 miles"
                  value="10-20"
                  checked={distanceLo === 10 && distanceHi === 20}
                  id="10 - 20 miles"
                  label="10 - 20 miles"
                />
              </li>
              <li>
                <Checkbox
                  name="20 - 40 miles"
                  value="20-40"
                  checked={distanceLo === 20 && distanceHi === 40}
                  id="20 - 40 miles"
                  label="20 - 40 miles"
                />
              </li>
              <li>
                <Checkbox
                  name="40 - 100 miles"
                  value="40-100"
                  checked={distanceLo === 40 && distanceHi === 100}
                  id="40 - 100 miles"
                  label="40 - 100 miles"
                />
              </li>
              <li>
                <Checkbox
                  name="> 100 miles"
                  value="100-9999"
                  checked={distanceLo === 100}
                  id="> 100 miles"
                  label="> 100 miles"
                />
              </li>
            </CheckboxList>
          </DropdownContainer>
        )}
      </Fragment>
    );
  }
}

export default DistanceSelector;
